import type { OverridableComponent } from '@material-ui/core/OverridableComponent'
import type { Theme } from '@material-ui/core/styles'
import { createStyles, withStyles } from '@material-ui/core/styles'
import type { TabsTypeMap } from '@material-ui/core/Tabs'
import MuiTabs from '@material-ui/core/Tabs'
import React from 'react'

const styles = (theme: Theme) => {
  return createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    indicator: {
      backgroundColor: theme.palette.primary.main
    },
    scrollButtons: {
      color: theme.palette.primary.main
    },
    flexContainer: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      gap: theme.spacing(2.5)
    }
  })
}

const Tabs: OverridableComponent<TabsTypeMap> = (props: any) => <MuiTabs {...props} />

export default withStyles(styles)(Tabs)
